import { EMAIL_REGEX } from "@/js/constants/index.js";

const validateEmail = email => {
  return EMAIL_REGEX.test(String(email).toLowerCase());
};

export default validateEmail;
